import { useSecureGraphqlLazyQuery } from '@psyomics/ui-common';
import { useCallback } from 'react';

import {
  GetReportReferrerAttachmentDownloadUrlDocument,
  GetReportReferrerAttachmentDownloadUrlQuery,
  GetReportReferrerAttachmentDownloadUrlQueryVariables,
  GetReportRespondentAttachmentDownloadUrlDocument,
  GetReportRespondentAttachmentDownloadUrlQuery,
  GetReportRespondentAttachmentDownloadUrlQueryVariables,
  ReportAttachment,
} from '../generated/report';

const useAttachmentDownloadUrl = () => {
  const getReferrerAttachmentDownloadUrl = useSecureGraphqlLazyQuery<
    GetReportReferrerAttachmentDownloadUrlQuery,
    GetReportReferrerAttachmentDownloadUrlQueryVariables
  >(GetReportReferrerAttachmentDownloadUrlDocument);

  const getRespondentAttachmentDownloadUrl = useSecureGraphqlLazyQuery<
    GetReportRespondentAttachmentDownloadUrlQuery,
    GetReportRespondentAttachmentDownloadUrlQueryVariables
  >(GetReportRespondentAttachmentDownloadUrlDocument);

  return useCallback(
    async (attachment: Pick<ReportAttachment, 'id' | 'respondentType'>, referralSessionId: string) => {
      const input = { attachmentId: attachment.id, referralSessionId };

      const url =
        attachment.respondentType === 'referrer'
          ? (await getReferrerAttachmentDownloadUrl({ input })).data?.getReportReferrerAttachmentDownloadUrl.url
          : (await getRespondentAttachmentDownloadUrl({ input })).data?.getReportRespondentAttachmentDownloadUrl.url;

      if (url) window.open(url, '_blank');
    },
    [getReferrerAttachmentDownloadUrl, getRespondentAttachmentDownloadUrl]
  );
};

export { useAttachmentDownloadUrl };
